import React from 'react';
import CoffeeChatManagement from '../../../components/admin/CoffeeChatManagement';

const CoffeeChatManagementPage: React.FC = () => {
  return <CoffeeChatManagement />;
};

export default CoffeeChatManagementPage;